import { useSidebar } from "@/context/sidebar-context";

export const CardsGrid = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { sidebarCollapsed } = useSidebar();

  const gridClasses = sidebarCollapsed
    ? "mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3"
    : "mt-10 grid grid-cols-1 gap-6 xl:grid-cols-2 min-w-1920:grid-cols-3";

  return <div className={`${gridClasses} ${className}`}>{children}</div>;
};
